import { Directive, forwardRef, Renderer2, ElementRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const ONLY_DIGITS_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => OnlyDigitsDirective),
    multi: true
};

@Directive({
    selector: '[only-digits]',
    host: {
        '(input)': 'onInput($event.target.value)',
        '(blur)': 'onBlur()'
    },
    providers: [ONLY_DIGITS_VALUE_ACCESSOR]
})
export class OnlyDigitsDirective implements ControlValueAccessor {

    private readonly validChars = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

    @Input('only-digits')
    extendedValidChars: string[] = [];

    constructor(protected renderer: Renderer2, protected elementRef: ElementRef) {
    }

    public onChange = (_: any) => {};

    public onTouched = () => {};

    public registerOnChange(fn: (value: any) => any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => any): void {
        this.onTouched = fn;
    }

    public onBlur() {
        this.onTouched();
    }

    public onInput(value: string) {
        const formatted: any = this.formatValue(value);
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', formatted);
        if (this.extendedValidChars && this.extendedValidChars.length) {
            this.onChange(formatted);
        } else {
            this.onChange(Number(formatted));
        }
    }

    public writeValue(value: any): void {
        if (typeof value === 'number') {
            value = value.toString();
        }

        const formatted: any = this.formatValue(value);
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', formatted);
    }

    private formatValue(value: any): string {
        return value && typeof value === 'string' ?
            this.validateChars(value) :
            '';
    }

    private validateChars(input: string): string {
        const inputValue = input.split('');
        const validChars = this.validChars.concat(this.extendedValidChars);

        for (let i = (inputValue.length - 1); i > -1; i--) {
            const val = inputValue[i];
            if (validChars.concat().indexOf(val) === -1) {
                inputValue.splice(i, 1);
            }
        }

        return inputValue.join('');
    }
}
